import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { cardSurface } from '../shared/Card';
import GoalIcon from './GoalIcon';

/**
 * The starter catalogue: a flat, localised list of goals people commonly keep.
 * Picking one fills the create form's name, icon and colour — the amount and
 * the dates stay the user's.
 *
 * Localised, not translated: the Spanish list names what people here save for.
 */
export function useGoalCatalogue() {
  const { t } = useTranslation('goals');
  const items = t('catalogue', { returnObjects: true });
  return Array.isArray(items) ? items : [];
}

export function GoalSuggestionChips({ onPick }) {
  const catalogue = useGoalCatalogue();
  if (catalogue.length === 0) return null;

  return (
    <Flex wrap="wrap" gap={2}>
      {catalogue.map((item) => (
        <Flex
          key={item.key}
          as="button"
          type="button"
          align="center"
          gap={2}
          px={2}
          py="5px"
          borderRadius="full"
          border="1px solid"
          borderColor="redesign.border.strong"
          _hover={{ bg: 'redesign.bg.hover' }}
          onClick={() => onPick(item)}
        >
          <GoalIcon goal={item} size={18} />
          <Text fontSize="xs" color="redesign.text">{item.name}</Text>
        </Flex>
      ))}
    </Flex>
  );
}

/** The same catalogue as cards, for the empty state. */
export default function GoalSuggestionCards({ onPick }) {
  const catalogue = useGoalCatalogue();
  if (catalogue.length === 0) return null;

  return (
    <Flex wrap="wrap" gap={3} justify="center">
      {catalogue.map((item) => (
        <Box
          key={item.key}
          as="button"
          type="button"
          textAlign="left"
          w="200px"
          p={3}
          {...cardSurface}
          _hover={{ borderColor: 'redesign.text.muted' }}
          onClick={() => onPick(item)}
        >
          <Flex align="center" gap={2} mb={2}>
            <GoalIcon goal={item} size={24} />
            <Text fontSize="sm" fontWeight={600} color="redesign.heading">{item.name}</Text>
          </Flex>
          <Text fontSize="xs" color="redesign.text.muted">{item.why}</Text>
        </Box>
      ))}
    </Flex>
  );
}
